import { BotClickManager } from "../BotClickManager";
import { ApiClientFactory } from "./clients";

export class BotClickManagerFactory {
  private readonly apiClientFactory: ApiClientFactory;

  constructor(baseUrl: string) {
    this.apiClientFactory = new ApiClientFactory(`${baseUrl}/api/v1`);
  }

  createBotClickManager(authToken: string): BotClickManager {
    return new BotClickManager(
      this.apiClientFactory.createAuthorizedApiClient(authToken)
    );
  }
}
